 import '../../scss/pages/product.scss';
import 'swiper/dist/css/swiper.css';
import 'glightbox/dist/css/glightbox.min.css';

import {AlcoholBox} from "../libraries/alcohol-box";
import {DefaultScreenDetector} from "../libraries/screen-detector/DefaultScreenDetector";
import {DefaultProductsCarousel} from "../libraries/product-list/DefaultProductsCarousel";
import {CustomerFeedback} from "../libraries/customer-feedback/CustomerFeedback";
import {DocumentRelativeOffset} from "../libraries/document-relative-offset";
import {CartCountElement} from "../libraries/CartCountElement";
import {SecurityContainer} from "../libraries/SecurityContainer";
import store from "./../vue/store";
import hcSticky from 'hc-sticky';
import {HashRouter} from "../libraries/HashRouter";
import Swiper from 'swiper';
import Vue from "vue";
import CuttableProductPreview from "@danhoss/cuttable-product-preview-component";
import {NotifyEmailClient} from "../http-clients/NotifyEmailClient";
import {ScreenDetectorFactory} from "../libraries/screen-detector/ScreenDetectorFactory";
import GLightbox from 'glightbox';
import {EventDispatcher} from "../libraries/event-dispatcher";

import lottie from 'lottie-web';
import { defineElement } from 'lord-icon-element';

defineElement(lottie.loadAnimation);

const documentRelativeOffset = new DocumentRelativeOffset();

const mobileBreakPoint = 850;
const mobileCallback = () => {
    return window.innerWidth < mobileBreakPoint && window.innerWidth < window.innerHeight;
};
const ScreenDetector = ScreenDetectorFactory.create(mobileCallback);

document.querySelectorAll('.product-description .tab-header').forEach((element) => {
    const isMobile = ScreenDetector.isMobileView();

    // setup mobile view:
    if (isMobile) {
        document.querySelectorAll('.product-description .attributes').forEach(contentElement => {
            contentElement.classList.add('hidden-section');
        });
    }

    // setup desktop view:
    document.querySelectorAll('.product-description .product-safety').forEach(contentElement => {
        contentElement.classList.add('hidden-section');
    });
    document.querySelectorAll('.product-description .manufacturers-data').forEach(contentElement => {
        contentElement.classList.add('hidden-section');
    });
    document.querySelectorAll('.product-description .payment').forEach(contentElement => {
        contentElement.classList.add('hidden-section');
    });
    document.querySelectorAll('.product-description .description').forEach(contentElement => {
        contentElement.classList.add('hidden-section');
    });

    element.addEventListener('click', (() => {
        const tabIsOpened = !element.classList.contains('hidden-section');
        if (tabIsOpened) {
            document.querySelectorAll('.product-description .attributes').forEach(contentElement => {
                contentElement.classList.add('hidden-section');
            });
            document.querySelectorAll('.product-description .description').forEach(contentElement => {
                contentElement.classList.add('hidden-section');
            });
            document.querySelectorAll('.product-description .shipping').forEach(contentElement => {
                contentElement.classList.add('hidden-section');
            });
            document.querySelectorAll('.product-description .payment').forEach(contentElement => {
                contentElement.classList.add('hidden-section');
            });
            document.querySelectorAll('.product-description .manufacturers-data').forEach(contentElement => {
                contentElement.classList.add('hidden-section');
            });
            document.querySelectorAll('.product-description .product-safety').forEach(contentElement => {
                contentElement.classList.add('hidden-section');
            });

            return;
        }

        let attributesSectionClicked = element.classList.contains('attributes');
        let shippingSectionClicked = element.classList.contains('shipping');
        let paymentSectionClicked = element.classList.contains('payment');
        let productSafetySectionClicked = element.classList.contains('product-safety');
        let manufacturersSectionClicked = element.classList.contains('manufacturers-data');
        let descriptionSectionClicked = element.classList.contains('description');

        let sectionToShow = '';
        let sectionsToHide = [''];

        if (attributesSectionClicked) {

            sectionToShow = 'attributes';
            sectionsToHide = ['description','payment','shipping','manufacturers-data','product-safety'];

        } else if (shippingSectionClicked) {

            sectionToShow = 'shipping';
            sectionsToHide = ['description','payment','attributes','manufacturers-data','product-safety'];

        } else if (paymentSectionClicked) {

            sectionToShow = 'payment';
            sectionsToHide = ['description','shipping','attributes','manufacturers-data','product-safety'];

        } else if (descriptionSectionClicked) {

            sectionToShow = 'description';
            sectionsToHide = ['shipping','payment','attributes','manufacturers-data','product-safety'];

        } else if (manufacturersSectionClicked) {

            sectionToShow = 'manufacturers-data';
            sectionsToHide = ['shipping','payment','attributes','description','product-safety'];

        } else if (productSafetySectionClicked) {

            sectionToShow = 'product-safety';
            sectionsToHide = ['shipping','payment','attributes','description','manufacturers-data'];

        }

        document.querySelectorAll('.product-description .' + sectionToShow).forEach((element) => {
            element.classList.remove('hidden-section');
        });
        sectionsToHide.forEach((sectionToHide) => {
            document.querySelectorAll('.product-description .' + sectionToHide).forEach((element) => {
                element.classList.add('hidden-section');
            });
        })

        if (sticky) {
            setTimeout(() => {
                sticky.refresh();
            }, 0)
        }

        let offset = documentRelativeOffset.getBySelectorOffset('.product-description');
        if (window.scrollY > offset.top) {
            window.scrollTo(0, 0.9 * offset.top);
        }

        initDetailsProductsHeight();
    }))
});

function initializeWishListToggleButton() {
    const currentProductId = CURRENT_PRODUCT_ID;
    const wishListToggleButtons = document.querySelectorAll('.wish-list-toggle-product');

    /**
     * @param productId
     * @return {boolean}
     */
    const productInWishList = productId => {
        const wishListProducts = store.getters['wishList/products'];
        const productModel = wishListProducts.find(model => model.id === productId);

        return !!productModel;
    };

    store.subscribe(mutation => {
        const mutationType = mutation.type;
        const mutationPayload = mutation.payload;

        switch (mutationType) {
            // Render icon when wish list will be fetch
            case 'wishList/setLoading':
                if (false === mutationPayload) {
                    const checked = productInWishList(currentProductId);

                    if (checked) {
                        wishListToggleButtons.forEach(button => {
                            const icon = button.querySelector('.icon');

                            icon.classList.remove('icon-heart');
                            icon.classList.add('icon-heart-filled')
                        });
                    }
                }
                break;
            case 'wishList/removeProductById':
                if (currentProductId === mutationPayload) {
                    wishListToggleButtons.forEach(button => {
                        const icon = button.querySelector('.icon');

                        icon.classList.remove('icon-heart-filled');
                        icon.classList.add('icon-heart');
                    });
                }
                break;
        }
    });

    wishListToggleButtons.forEach(button => {
        button.addEventListener('click', (() => {
            if (false === SecurityContainer.userIsLogged()) {
                HashRouter.redirect('login-modal', {type: "wishlist"});
            } else {
                const toggleProduct = async () => {
                    const productIsChecked = productInWishList(currentProductId);
                    const icon = button.querySelector('.icon');

                    icon.classList.remove('icon-heart');
                    icon.classList.remove('icon-heart-filled');
                    icon.classList.add('icon-loading');
                    icon.classList.add('icon-rotate');

                    const storeAction = productIsChecked
                        ? 'wishList/removeProductById'
                        : 'wishList/addProductById'
                    ;

                    try {
                        await store.dispatch(storeAction, currentProductId);
                    } catch (error) {
                        toast.error("Wystąpił błąd")
                    }

                    icon.classList.remove('icon-loading');
                    icon.classList.remove('icon-rotate');

                    if (productIsChecked) {
                        icon.classList.add('icon-heart');
                    } else {
                        icon.classList.add('icon-heart-filled');
                    }
                };

                toggleProduct();
            }
        }));
    })
}


function initUpSellingView() {
    const container = document.querySelector('#up-selling-view');

    if (container) {
        document.body.classList.add('show-up-selling-container');

        const closeButtons = container.querySelectorAll('.close-up-selling-container');

        for (let closeButton of closeButtons) {
            closeButton.addEventListener('click', () => {
                setTimeout(() => {
                    container.remove();

                    if (false === DefaultScreenDetector.isMobileView()) {
                        initializeStickyContent();
                    }
                }, 500)
            })
        }
    }
}

let sticky = null;

function initializeStickyContent() {
    sticky = new hcSticky('.product-info-content', {
        stickTo: '.product-info',
        top: 60,
    });
}

function destroyStickyContent() {
    if (sticky) {
        sticky.destroy();
        sticky = null;
    }
}

function initializeProducerContainer() {
    const containerSelector = '.product-producer-container';
    const nextButtonsSelector = '.description-item-link';

    const container = document.querySelector(containerSelector);
    if (!container) {
        return
    }

    const galleryCarousel = new Swiper(containerSelector  + ' .product-producer-gallery.swiper-container', {
        continuous: true,
        slidesPerView: 2.6,
        centeredSlides: true,
        breakpoints: {
            1300: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: 1,
                centeredSlides: false,
            }
        },
    });

    const descriptionCarousel = new Swiper(containerSelector  + ' .product-producer-description.swiper-container', {
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

    galleryCarousel.controller.control = descriptionCarousel;
    descriptionCarousel.controller.control = galleryCarousel;

    const nextButtonsAll = container.querySelectorAll(nextButtonsSelector);
    if (nextButtonsAll) {
        for (let button of nextButtonsAll) {
            button.addEventListener('click', (event) => {
                event.preventDefault();

                if (descriptionCarousel.isEnd) {
                    galleryCarousel.slideTo(0);
                    descriptionCarousel.slideTo(0);
                } else {
                    galleryCarousel.slideNext();
                }
            })
        }
    }
}

function initializeCuttable() {
    const cuttableImageContainer = document.querySelector('#cuttable-image');
    if (cuttableImageContainer) {
        const vue = new Vue({
            components: {
                CuttableProductPreview
            }
        });
        vue.$mount(cuttableImageContainer);
    }
}

function handleSubcategoriesDesktop() {
    const subcategoryToggleMore = document.querySelector('#subcategory-desktop .subcategory-toggle-more');
    const subcategoryToggleLess = document.querySelector('#subcategory-desktop .subcategory-toggle-less');
    const subcategoryContent = document.querySelector('#subcategory-desktop .subcategory-content');

    if (!subcategoryToggleMore || !subcategoryToggleLess || !subcategoryContent) {
        return
    }

    const subcategoryItemsHeight = getComputedStyle(document.querySelector('#subcategory-desktop .subcategory-items')).getPropertyValue("height");

    if (parseInt(subcategoryItemsHeight) > 50) {
        subcategoryToggleMore.style.display = 'block';
        subcategoryToggleLess.style.display = 'none';

        subcategoryToggleMore.addEventListener('click', (event) => {
            event.preventDefault();

            subcategoryContent.classList.remove('subcategory-hidden');
            subcategoryToggleMore.style.display = 'none';
            subcategoryToggleLess.style.display = 'block';
            return false;
        });

        subcategoryToggleLess.addEventListener('click', (event) => {
            event.preventDefault();

            subcategoryContent.classList.add('subcategory-hidden');
            subcategoryToggleMore.style.display = 'block';
            subcategoryToggleLess.style.display = 'none';
            return false;
        });
    } else {
        subcategoryToggleMore.style.display = 'none';
        subcategoryToggleLess.style.display = 'none';
    }
}

const Carousels = {
    subcategoriesSlider: null,
    associationSlider: null,

    init() {
        const subcategoriesSliderSelector = '#subcategory-mobile .subcategories-slider.swiper-container';
        Carousels.subcategoriesSlider = new Swiper(subcategoriesSliderSelector, {
            slidesPerView: 'auto',
            spaceBetween: 4,
            noSwiping: true,
            noSwipingClass: 'swiper-no-swiping',
            scrollbar: {
                el: '#subcategory-mobile .swiper-scrollbar',
                hide: false,
            },
        });

        const associationGiftSelector = '#modal-wrapper-content .subcategories-slider.swiper-container';
        Carousels.associationSlider = new Swiper(associationGiftSelector, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            preloadImages: false
        });
    }
};

function handleSubcategoriesMobile() {
    const subcategoryToggleMore = document.querySelector('#subcategory-mobile .subcategory-toggle-more');
    const subcategoryToggleLess = document.querySelector('#subcategory-mobile .subcategory-toggle-less');
    const subcategoryWrapper = document.querySelector('#subcategory-mobile .subcategory-content .swiper-wrapper');

    if (!subcategoryToggleMore || !subcategoryToggleLess || !subcategoryWrapper) {
        return
    }

    subcategoryToggleMore.style.display = 'block';
    subcategoryToggleLess.style.display = 'none';

    const swiperScrollbar = document.querySelector('#subcategory-mobile .subcategory-content .swiper-scrollbar');

    subcategoryToggleMore.addEventListener('click', (event) => {
        event.preventDefault();

        if (swiperScrollbar) {
            swiperScrollbar.style.display = 'none';
        }

        subcategoryWrapper.classList.add('swiper-no-swiping');
        subcategoryWrapper.style.display = 'block';
        subcategoryWrapper.style.transform = 'translate3d(0, 0, 0)';
        subcategoryWrapper.style.textAlign = 'center';

        subcategoryToggleMore.style.display = 'none';
        subcategoryToggleLess.style.display = 'block';
        return false;
    });

    subcategoryToggleLess.addEventListener('click', (event) => {
        event.preventDefault();

        if (swiperScrollbar) {
            swiperScrollbar.style.display = 'block';
        }

        subcategoryWrapper.classList.remove('swiper-no-swiping');
        subcategoryWrapper.style.display = 'flex';
        subcategoryWrapper.style.transform = 'translate3d(0, 0, 0)';
        subcategoryWrapper.style.textAlign = 'left';

        subcategoryToggleMore.style.display = 'block';
        subcategoryToggleLess.style.display = 'none';
        return false;
    });

    Carousels.init();
}

function validateEmail(x) {
    var filter  = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (filter.test(x)) {
        return true;
    } else {
        return false;
    }
}

function initializeNotifyEmail() {
    const buttonNotifySubmit = document.querySelector('.button-notify-submit');

    if (!buttonNotifySubmit) {
        return
    }

    buttonNotifySubmit.addEventListener('click', (event) => {
        event.preventDefault();

        const client = new NotifyEmailClient();
        const modalMessage = document.querySelector('.modal-message');
        const emailElement = document.querySelector('.notify_email');
        const email = emailElement.value;
        const productId = document.querySelector('.product_id').value;

        modalMessage.style.display = '';

        if (email.length>0 && validateEmail(email) && productId>0) {

            try {
                const result = client.send(
                    email,
                    productId
                ).then((result) => {

                    modalMessage.style.display = 'none';
                    emailElement.value = '';
                    toast.success(result);

                });
            } catch (error) {
                modalMessage.style.display = 'none';
                toast.error("Błąd podczas zapisu do bazy");
            }

        } else {
            modalMessage.style.display = 'none';
            toast.error("Wpisz poprawnie adres email");
        }

        return false;
    });
}

function bindGalleryPopupHandler() {
    const lightbox = GLightbox({
        selector: '.additional-image',
        touchNavigation: true,
        loop: true,
        preload: true,
        zoomable: true,
    });

    EventDispatcher.$on('key:esc', () => {
        lightbox.close();
    });

    return this;
}

/**
 * @return {boolean}
 */
function hideZendeskWidget() {
    if (typeof zE == 'function') {
        if (window.zE.widget === 'messenger') {
            zE("messenger", "hide");
        } else {
            zE("webWidget", "hide");
        }
        return true;
    }
    return false;
}

function initAssociationGift() {
    const container = document.querySelector('#association-gift');
    if (!container) {
        return
    }

    const modal = document.querySelector('#modal-association-inner');
    if (!modal) {
        return
    }

    container.querySelectorAll('.show-association-gift').forEach(button => {
        button.addEventListener('click', () => {
            event.preventDefault();

            document.querySelector('#modal-association-inner').style.display = 'flex';

            const mySwiper = document.querySelector('#modal-wrapper-content .subcategories-slider.swiper-container').swiper;
            mySwiper.update();
        })
    })

    modal.addEventListener('click', () => {
        event.preventDefault();

        document.querySelector('#modal-association-inner').style.display = 'none';
    })

    modal.querySelector('#modal-wrapper-inner').addEventListener('click', () => {
        event.preventDefault();
        event.stopPropagation();
    })

    modal.querySelector('#modal-close').addEventListener('click', () => {
        event.preventDefault();
        event.stopPropagation();

        document.querySelector('#modal-association-inner').style.display = 'none';
    })

    modal.querySelector('#modal-mobile-close').addEventListener('click', () => {
        event.preventDefault();
        event.stopPropagation();

        document.querySelector('#modal-association-inner').style.display = 'none';
    })
}

function initDetailsProductsHeight() {
    const container = document.querySelector('#details-products-height');
    if (!container) {
        return
    }

    const positionInfo = container.getBoundingClientRect();

    if (positionInfo.height >= 150) {

        const tabIsOpened = container.classList.contains('limit-height');

        const containerButton = document.querySelector('#details-products-height-button');
        if (containerButton && tabIsOpened) {
            containerButton.style.display = 'block';

            containerButton.addEventListener('click', () => {
                event.preventDefault();
                event.stopPropagation();

                container.classList.remove('limit-height');
                containerButton.style.display = 'none';

                return false;
            })
        }
    }
}

 function initSendStraight() {
     document.querySelectorAll('.table-send-straight').forEach(button => {
         button.addEventListener('click', () => {
             event.preventDefault();

             const innerText = button.querySelector('#inner-send-straight');
             if (innerText) {
                 if (innerText.style.display === 'none') {
                     innerText.style.display = 'block';
                 } else {
                     innerText.style.display = 'none';
                 }
             }

             const circle = button.querySelector('span');
             if (circle) {
                 const circlePlus = circle.classList.contains('circle-arrow-button-plus');
                 circle.classList.remove('circle-arrow-button-plus');
                 circle.classList.remove('circle-arrow-button-minus');
                 if (circlePlus) {
                     circle.classList.add('circle-arrow-button-minus');
                 } else {
                     circle.classList.add('circle-arrow-button-plus');
                 }
             }
         })
     })
 }

 function initialize() {
    const alcoholBox = new AlcoholBox();
    alcoholBox.showSiteMessage();

    new CustomerFeedback();
    new DefaultProductsCarousel();
    new CartCountElement(document);

    initializeWishListToggleButton();
    initUpSellingView();
    bindGalleryPopupHandler();
    initializeProducerContainer();
    initializeCuttable();
    initializeNotifyEmail();
    initAssociationGift();
    initDetailsProductsHeight();
    initSendStraight();

    handleSubcategoriesDesktop();
    handleSubcategoriesMobile();

    if (true === DefaultScreenDetector.isMobileView()) {
        let counter = 0;
        let i = setInterval(function(){
            const hidden = hideZendeskWidget();
            counter++;
            if(counter === 30 || hidden) {
                clearInterval(i);
            }
        }, 200);
    }
}

function onScroll() {
    const filtersContainer = document.querySelector('.top-filters-container');
    const horizontalDesktopMenu = document.querySelector('.horizontal-desktop-menu');
    if (!filtersContainer || !horizontalDesktopMenu) {
        return;
    }

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 100) {
        const filtersContainerStyle = getComputedStyle(filtersContainer);
        if (scrollTop > lastScrollTop) {
            filtersContainer.style.top = '-75px';
            if (filtersContainerStyle.getPropertyValue("height") === '52px') {
                filtersContainer.style.animation = 'scroll-out-filters-bar-mobile 0.4s ease-out';
            } else {
                filtersContainer.style.animation = 'scroll-out-filters-bar 0.4s ease-in';
            }
            horizontalDesktopMenu.style.top = '0';
            horizontalDesktopMenu.style.animation = 'scroll-out-menu-bar 0.4s ease-in';
        } else {
            if (filtersContainerStyle.getPropertyValue("height") === '52px') {
                filtersContainer.style.top = filtersContainerStyle.height;
                filtersContainer.style.animation = 'scroll-in-filters-bar-mobile 0.4s ease-out';
            } else {
                filtersContainer.style.top = '60px';
                filtersContainer.style.animation = 'scroll-in-filters-bar 0.4s ease-out';
            }
            horizontalDesktopMenu.style.top = '135px';
            horizontalDesktopMenu.style.animation = 'scroll-in-menu-bar 0.4s ease-out';
        }
    }
    lastScrollTop = scrollTop;
}

document.addEventListener('DOMContentLoaded', initialize);

var lastScrollTop = 0;
window.addEventListener('scroll', onScroll);

if (false === DefaultScreenDetector.isMobileView()) {
    initializeStickyContent();
}
DefaultScreenDetector.listener.onDesktopToMobileChange(() => {
    destroyStickyContent();
});
DefaultScreenDetector.listener.onMobileToDesktopChange(() => {
    initializeStickyContent();
});
